<template>
    <div class="welcome">
        <div class="quickly quickly-inner">
            <div class="btnList">
                <Permission allowed="user.admins.list">
                    <div class='items' @click="$router.push({path: '/user/users/list'})">
                        <div>
                            <img src="../../../assets/img/user-list.png" />
                        </div>
                        <span class="name">用户列表</span>
                    </div>
                </Permission>
                <Permission allowed="user.roles.list">
                    <div class='items' @click="$router.push({path: '/user/roles/list'})">
                        <div>
                            <img src="../../../assets/img/role-list.png" />
                        </div>
                        <span class="name">角色列表</span>
                    </div>
                </Permission>
                <Permission allowed="user.factor-admins.list">
                    <div class='items' @click="$router.push({path: '/user/factor-admin/list'})">
                        <div>
                            <img src="../../../assets/img/admin-list.png" />
                        </div>
                        <span class="name">代理商超管用户</span>
                    </div>
                </Permission>
                <Permission allowed="user.logs.list">
                    <div class='items' @click="$router.push({path: '/user/logs/list'})">
                        <div>
                            <img src="../../../assets/img/log-list.png" />
                        </div>
                        <span class="name">操作日志列表</span>
                    </div>
                </Permission>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserWelcome'
}
</script>
<style scoped lang="less">
@import url('../../../assets/style/welcome.less');
</style>